// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"615":"40f888b5","668":"c18c2ded","684":"bc2382bf"}[chunkId] + ".chunk.js";
};